import React, { Component } from 'react';
import ActivityIndicator from '@lyearn-team/frontend-components/dist/Loader';
import Icon from '@lyearn-team/frontend-components/dist/Icon';
import globalURL from 'helper/url';

import DarkBoxInput from '@lyearn-team/frontend-components/dist/Input/DarkBoxInput';
import DarkButton from '@lyearn-team/frontend-components/dist/Button/DarkButton';
import {
  Row,
  FixWidthColumn,
  CompanyPageWrapper,
  IntroText,
  FixText,
  textButton,
  SearchInputWrapper,
  buttonClass,
  CloseButton,
  inputClass,
  closeButton
} from './styles';
import FindOrganization from '../DarkFindOrganization';
import { LoginContentHeading } from '../styles';

const getReplacedUrl = url => {
  const urlParts = url.split('.');
  if (urlParts.length === 3) {
    return `${urlParts[1]}.${urlParts[2]}`;
  }
  return url;
};

export default class DarkSelectOrganization extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showURLInfoPopup: false,
      loading: false,
      errorMessage: ''
    };
    this.defaultCompanyName = '';
  }

  componentDidMount() {
    const href = window.location.search;
    if (href.indexOf('?cn=') > -1) {
      this.defaultCompanyName = href.split('=')[href.split('=').length - 1];
      if (this.defaultCompanyName === 'undefined') {
        this.defaultCompanyName = '';
      }
      this.checkIfOrganizationExist();
    }
  }

  onOrganizationNameChange = e => {
    const { errorMessage } = this.state;
    if (errorMessage) {
      this.setState({ errorMessage: '' });
    }
    this.defaultCompanyName = e.target.value;
    this.setState({});
  };

  onEnter = e => {
    if (e.keyCode === 13) {
      this.checkIfOrganizationExist();
    }
  };

  checkIfOrganizationExist = event => {
    event && event.preventDefault();
    const { defaultCompanyName } = this;
    if (!defaultCompanyName) {
      this.setState({ errorMessage: 'Please enter company name' });
      return;
    }
    this.setState({ loading: true });
    const url = `${globalURL.awsEndpoint}/checkIfSubDomainExists?subDomain=${defaultCompanyName}`;
    fetch(url)
      .then(response => response.json())
      .then(data => {
        this.setState({ loading: false });
        if (!data.success && data.message === 'SUB_DOMAIN_NOT_FOUND') {
          this.setState({ errorMessage: 'That organization doesn’t exist, please try again.' });
          return;
        }
        if (!data.success) {
          return;
        }
        if (data.success) {
          const domain = window.location.host.split('.')[0];
          if (!window.__appEnvironment) {
            window.location.href =
              'http://' + defaultCompanyName + '.localhost:' + window.location.port + '/#/login';
          } else if (window.__appEnvironment === 'development') {
            window.location.href =
              window.location.origin + '/?cn=' + defaultCompanyName + '#/login';
          } else if (window.__appEnvironment === 'production') {
            if (window.devSubdomains.indexOf(domain) > -1) {
              window.location.href =
                window.location.origin + '/?cn=' + defaultCompanyName + '#/login';
            } else {
              const toBeReplaced = window.location.origin.replace(/https?:\/\//i, '');
              if (toBeReplaced.indexOf('www') > -1) {
                window.location.href =
                  window.location.protocol +
                  '//' +
                  defaultCompanyName +
                  '.' +
                  getReplacedUrl(toBeReplaced) +
                  '/#/login';
              } else {
                window.location.href =
                  window.location.protocol +
                  '//' +
                  defaultCompanyName +
                  '.' +
                  getReplacedUrl(toBeReplaced) +
                  '/#/login';
              }
            }
          }
        }
      })
      .catch(err => {
        console.log('Error', err);
      });
  };

  togglePopup = () => {
    this.setState({ showURLInfoPopup: !this.state.showURLInfoPopup });
  };

  renderActivityIndicator = () => (
    <ActivityIndicator
      svgColor="#fff"
      style={{ marginRight: '6px', fill: '#fff' }}
      width={16}
      height={16}
    />
  );

  render() {
    const { defaultCompanyName, state } = this;
    const { showURLInfoPopup, loading } = state;
    let icon = '';
    if (loading) {
      icon = this.renderActivityIndicator();
    }

    if (showURLInfoPopup) {
      return (
        <CompanyPageWrapper className="pageWrapper">
          <CloseButton onClick={this.togglePopup}>
            <Icon type="close" className={closeButton} style={{ width: '16px', height: '16px' }} />
          </CloseButton>
          <FindOrganization />
        </CompanyPageWrapper>
      );
    }

    return (
      <CompanyPageWrapper className="pageWrapper">
        <LoginContentHeading>Hello, welcome to Lyearn!</LoginContentHeading>
        <IntroText>ENTER ORGANIZATION URL</IntroText>
        <form className={FixWidthColumn} onSubmit={this.checkIfOrganizationExist}>
          <Row>
            <SearchInputWrapper>
              <DarkBoxInput
                className={inputClass}
                placeholder="Your organization"
                value={defaultCompanyName}
                onChange={this.onOrganizationNameChange}
              />
            </SearchInputWrapper>
            <FixText>.lyearn.com</FixText>
          </Row>
          <DarkButton
            className={buttonClass}
            type="submit"
            disabled={loading || !defaultCompanyName}
          >
            {icon}
            {loading ? 'Continuing' : 'Continue'}
          </DarkButton>
        </form>
        <DarkButton.TextButton className={textButton} onClick={this.togglePopup}>
          Don&apos;t know your organization&apos;s URL?
        </DarkButton.TextButton>
      </CompanyPageWrapper>
    );
  }
}
